import React from 'react';
import Header from '../../components/Header';
import Sidebar from '../../components/Sidebar';
import CRMPage from './CRMPageReal';
import { useAuth } from '../../hooks/useAuth';
import { useIsMobile } from '../../hooks/useIsMobile';

function CRMPageWrapper() {
  const { profile } = useAuth();
  const isMobile = useIsMobile();
  const userName = profile?.name || 'Usuário';

  const containerStyle = {
    display: 'flex',
    flexDirection: 'column',
    height: isMobile ? '100dvh' : '100vh',
    overflow: 'hidden'
  };

  return (
    <div style={containerStyle}>
      {!isMobile && <Header subtitle="Conversas" userName={userName} />}
      <div style={{ display: 'flex', flex: 1, overflow: 'hidden' }}>
        {!isMobile && <Sidebar activePage="conversas" />}
        <CRMPage />
      </div>
      {isMobile && <Sidebar activePage="conversas" />}
    </div>
  );
}

export default CRMPageWrapper;
